<script>
export default {
    name: 'noItemFound',
    props: {
        itemName: {
            type: String,
            required: true
        },
        link: {
            type: String,
            default: '/produkte'
        },
        linkExternal: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: 'fi fi-rr-shopping-cart-add'
        }
    }
};
</script>

<template>
    <div class="bg-dashboard-primary p-20 rounded-xl">
        <p class="text-center text-dashboard-primary-grey mb-3">
            <i class="fi fi-rr-cross-circle justify-center align-middle text-xs text-dashboard-primary-grey" />
            {{ $t('no_item_found', { itemName: itemName }) }}
        </p>
        <div>
            <a v-if="linkExternal" class="w-full justify-between text-center text-base flex-col gap-2 flex" :href="link" target="_blank">
                <i
                    :class="icon"
                    class="w-20 self-center hover:scale-105 duration-300 rounded-xl bg-white-light p-4 text-dashboard-primary-grey align-center text-3xl text-dashboard-primary-grey shadow-md"
                />
            </a>
            <router-link v-else class="w-full justify-between text-center text-base flex-col gap-2 flex" :to="link">
                <i
                    :class="icon"
                    class="w-20 self-center hover:scale-105 duration-300 rounded-xl bg-white-light p-4 text-dashboard-primary-grey align-center text-3xl text-dashboard-primary-grey shadow-md"
                />
            </router-link>
        </div>
        <div></div>
    </div>
</template>

<style scoped></style>
